import { type ObjectValuesUnionType } from '../utils/typing';

import { Licence, Licences } from './common';

export const BetTemplates = Object.freeze({
  THREE_WAY: '3way',
  TWO_WAY: '2way',
  LIST: 'List',
  LIST_ODD: 'ListOdd',
  OVER_UNDER: 'OverUnder',
  SCORE: 'Score',
  SET_SCORE: 'SetScore',
  DYNAMIC: 'dynamic',
  ASIAN_HANDICAP: 'asian_handicap',
  ASIAN_TEXT_HANDICAP: 'asiantext_handicap',
});
export type BetTemplate = ObjectValuesUnionType<typeof BetTemplates>;

export const SpecialBetGroups = Object.freeze({
  SOCCER_SCORERS_LIVE: 'special:scorers_live',
  SOCCER_SCORERS_LIVE_WITHOUT_LAST_SCORER: 'special:scorers_live_without_last_scorer',
  SOCCER_MULTI_SCORERS_LIVE: 'special:multiscorers_live',
  SOCCER_MULTI_SCORERS_PREMATCH: 'special:multiscorers',
  SOCCER_SCORERS_PREMATCH: 'special:goalscorers',
  MULTICHOICE_MM_SOCCER_SCORERS: 'special:multichoice_mm_goalscorers',
  SOCCER_DECISIVE_PLAYERS: 'special:decisive_players',
  BETBUILDER: 'special:betbuilder',
  TOP_MY_MATCHS: 'special:top_my_matchs',
  SOCCER_ASIAN_HANDICAP: 'special:asian_handicap',
  SOCCER_ASIANTEXT_HANDICAP: 'special:asiantext_handicap',
  SOCCER_SCORERS_GOAL_TYPE: 'special:scorers_goal_type',
  SOCCER_SCORER_VS_COMPETITOR: 'special:scorers_vs_competitor',
  SOCCER_SCORER_VS_SCORER: 'special:scorer_vs_scorer',
  SOCCER_SCORERS_AND_TEAM_WINS: 'special:scorer_and_team_wins',
  SOCCER_NEXT_SCORERS_OVERTIME: 'special:next_scorer_overtime',
  SOCCER_SCORERS_OVERTIME: 'special:scorer_overtime',
  SOCCER_OVER_2_SCORERS_OVERTIME: 'special:scorer:over_2_overtime',
  SOCCER_SCORERS_OVERTIME_1_HT: 'special:scorer:overtime_1_ht',
  SOCCER_SCORERS_OVERTIME_2_HT: 'special:scorer:overtime_2_ht',
  SOCCER_COMPETITOR_GOAL_TYPE: 'special:competitor_goal_type',
  SOCCER_DUO_SCORERS: 'special:soccer_duo_scorers',
  SOCCER_TRIO_SCORERS: 'special:soccer_trio_scorers',
  SOCCER_SCORER_PERIOD_10MINUTES: 'special:soccer_scorer_period_10minutes',
  SOCCER_SCORER_PERIOD_15MINUTES: 'special:soccer_scorer_period_15minutes',
  SOCCER_SCORER_PERIOD_HALF_TIME: 'special:soccer_scorer_period_half_time',
  SOCCER_MULTI_SCORER_1_HT: 'special:soccer_multi_scorer_1_ht',
  SOCCER_MULTI_SCORER_2_HT: 'special:soccer_multi_scorer_2_ht',
  SOCCER_NUMBER_CARD_PLAYER: 'special:soccer_number_card_player',
  SOCCER_PLAYER_PROPS_ASSISTS: 'special:soccer_player_props_assists',
  SOCCER_PLAYER_PROPS_SHOTS: 'special:soccer_player_props_shots',
  SOCCER_PLAYER_PROPS_SHOTS_ON_GOAL: 'special:soccer_player_props_shots_on_goal',
  SOCCER_PLAYER_PROPS_PASSES: 'special:soccer_player_props_passes',
  SOCCER_PLAYER_PROPS_TACKLES: 'special:soccer_player_props_tackles',
  BASKETBALL_POINT_PLAYER: 'special:basketball_point_player',
  BASKETBALL_PASS_PLAYER: 'special:basketball_pass_player',
  BASKETBALL_REBOUND_PLAYER: 'special:basketball_rebound_player',
  BASKETBALL_3POINT_PLAYER: 'special:basketball_3point_player',
  BASKETBALL_POINT_PLAYER_OVER_UNDER: 'special:basketball_point_player_over_under',
  BASKETBALL_DOUBLE_CHANCE_PLAYER: 'special:basketball_double_chance_player',
  BASKETBALL_SUM_POINT_2PLAYERS: 'special:basketball_sum_point_2players',
  BASKETBALL_SUM_POINT_3PLAYERS: 'special:basketball_sum_point_3players',
  BASKETBALL_PASS_PLAYER_OVER_UNDER: 'special:basketball_pass_player_over_under',
  BASKETBALL_REBOUND_PLAYER_OVER_UNDER: 'special:basketball_rebound_player_over_under',
  BASKETBALL_3POINTS_PLAYER_OVER_UNDER: 'special:basketball_3points_player_over_under',
  BASKETBALL_POINT_REBOUND_ASSIST_PLAYER_OVER_UNDER: 'special:basketball_point_rebound_assist_player_over_under',
  BASKETBALL_POINT_PASS_PLAYER_OVER_UNDER: 'special:basketball_point_pass_player_over_under',
  BASKETBALL_PASS_REBOUND_PLAYER_OVER_UNDER: 'special:basketball_pass_rebound_player_over_under',
  BASKETBALL_POINT_REBOUND_PLAYER_OVER_UNDER: 'special:basketball_point_rebound_player_over_under',
  BASKETBALL_PLAYER_INTERCEPT_OVER_UNDER: 'special:basketball_player_intercept_over_under',
  BASKETBALL_PLAYER_BLOCK_OVER_UNDER: 'special:basketball_player_block_over_under',
  BASKETBALL_PLAYER_LOST_BALL_OVER_UNDER: 'special:basketball_player_lost_ball_over_under',
  BASKETBALL_TOTAL_PLAYER_INTERCEPT_BLOCK_OVER_UNDER: 'special:basketball_total_player_intercept_block_over_under',
  BASKETBALL_TOTAL_PLAYER_POINTS_REBOUND_ASSIST: 'special:basketball_total_player_points_rebound_assist',
  BASKETBALL_TOTAL_PLAYER_POINTS_ASSIST: 'special:basketball_total_player_points_assist',
  BASKETBALL_TOTAL_PLAYER_ASSIST_REBOUND: 'special:basketball_total_player_assist_rebound',
  BASKETBALL_TOTAL_PLAYER_POINTS_REBOUND: 'special:basketball_total_player_points_rebound',
  BASKETBALL_PLAYER_INTERCEPT: 'special:basketball_player_intercept',
  BASKETBALL_PLAYER_BLOCK: 'special:basketball_player_block',
  BASKETBALL_PLAYER_LOST_BALL: 'special:basketball_player_lost_ball',
  BASKETBALL_TOTAL_PLAYER_INTERCEPT_BLOCK: 'special:basketball_total_player_intercept_block',
  BASKETBALL_NUMBER_OF_REBOUNDS_HEAD_TO_HEAD: 'special:basketball_number_of_rebounds_head_to_head',
  BASKETBALL_NUMBER_OF_ASSISTS_HEAD_TO_HEAD: 'special:basketball_number_of_assists_head_to_head',
  BASKETBALL_NUMBER_OF_POINTS_HEAD_TO_HEAD: 'special:basketball_number_of_points_head_to_head',
  ICE_HOCKEY_SCORERS: 'special:ice_hockey_scorers',
  ICE_HOCKEY_SCORER_LIVE: 'special:ice_hockey_scorer_live',
  ICE_HOCKEY_MULTI_SCORER_LIVE: 'special:ice_hockey_multi_scorer_live',
  ICE_HOCKEY_DUO_SCORERS: 'special:ice_hockey_duo_scorers',
  ICE_HOCKEY_TRIO_SCORERS: 'special:ice_hockey_trio_scorers',
  ICE_HOCKEY_SCORER_PERIOD: 'special:ice_hockey_scorer_first_period',
  MULTICHOICE_MM_ICE_HOCKEY_SCORERS: 'special:multichoice_mm_ice_hockey_scorers',
  FOOTBALL_SCORERS: 'special:football_scorers',
  MULTICHOICE_MM_FOOTBALL_SCORERS: 'special:multichoice_mm_football_scorers',
  RUGBY_SCORERS: 'special:rugby_scorers',
  RUGBY_DUO_SCORERS: 'special:rugby_duo_scorers',
  RUGBY_TRIO_SCORERS: 'special:rugby_trio_scorers',
  MULTICHOICE_MM_RUGBY_SCORERS: 'special:multichoice_mm_rugby_scorers',
  RUGBY_LEAGUE_SCORERS: 'special:rugby_league_scorers',
  MULTICHOICE_MM_RUGBY_LEAGUE_SCORERS: 'special:multichoice_mm_rugby_league_scorers',
  RUGBY_7S_SCORERS: 'special:rugby_7s_scorers',
  RUGBY_SCORERS_LIVE: 'special:rugby_scorers_live',
  RUGBY_LEAGUE_SCORERS_LIVE: 'special:rugby_league_scorers_live',
  RUGBY_7S_SCORERS_LIVE: 'special:rugby_7s_scorers_live',
  HANDBALL_SCORERS_PLAYER: 'special:handball_scorers_player',
});
export type SpecialBetGroup = ObjectValuesUnionType<typeof SpecialBetGroups>;

export const BetTypes = Object.freeze({
  SOCCER_RESULT: 3178,
  SOCCER_SCORER_GOAL_TYPE: 5691,
  SOCCER_SCORER_VS_SCORER: 5692,
  SOCCER_SCORER_VS_COMPETITOR_1: 5693,
  SOCCER_SCORER_VS_COMPETITOR_2: 5694,
  SOCCER_ANYTIME_SCORER: 2705,
  SOCCER_NEXT_SCORER_LIVE: 3115,
  SOCCER_MULTI_SCORERS: 3876,
  SOCCER_FIRST_SCORER: 4189,
  SOCCER_LAST_SCORER: 4190,
  SOCCER_SCORER_AND_TEAM_WINS: 4191,
  SOCCER_NEXT_SCORERS_OVERTIME: 5589,
  SOCCER_SCORERS_OVERTIME: 5830,
  SOCCER_OVER_2_SCORERS_OVERTIME: 5831,
  SOCCER_SCORERS_OVERTIME_HALF_TIME_FIRST: 5832,
  SOCCER_SCORERS_OVERTIME_HALF_TIME_SECOND: 5833,
  SOCCER_MULTI_SCORERS_2: 2851,
  SOCCER_MULTI_SCORERS_3: 2711,
  SOCCER_PLAYER_PROP_ASSISTS: 3361,
  SOCCER_EXACT_SCORE: 2643,
  SOCCER_HALF_TIME_EXACT_SCORE: 3046,
  SOCCER_DOUBLE_CHANCE_SCORER: 4193,
  SOCCER_TRIPLE_CHANCE_SCORER: 4194,
  SOCCER_EXACT_SCORE_MULTICHANCE: 3379,
  SOCCER_MULTI_SCORERS_PREMATCH: 4195,
  SOCCER_ASIAN_HANDICAP_CORNER: 2482,
  SOCCER_ASIAN_HANDICAP_CORNER_FIRST_HALF: 2441,
  SOCCER_ASIAN_HANDICAP_GOAL_DIFFERENCE: 3090,
  SOCCER_ASIAN_HANDICAP_GOAL_DIFFERENCE_WX: 5201,
  SOCCER_ASIAN_HANDICAP_GOAL_DIFFERENCE_OVERTIME: 2694,
  SOCCER_ASIAN_HANDICAP_GOAL_DIFFERENCE_FIRST_HALF: 3492,
  SOCCER_ASIAN_HANDICAP_GOAL_DIFFERENCE_FIRST_HALF_OVERTIME: 3438,
  SOCCER_ASIANTEXT_HANDICAP_GOAL_DIFFERENCE: 4367,
  SOCCER_COMPETITOR_GOAL_TYPE_PENALTY: 5690,
  SOCCER_COMPETITOR_GOAL_TYPE_HEAD: 5689,
  SOCCER_COMPETITOR_GOAL_TYPE_FREEKICK: 5688,
  SOCCER_SCORER_HALF_TIME_FIRST: 5657,
  SOCCER_SCORER_HALF_TIME_SECOND: 5658,
  SOCCER_SCORER_HALF_TIME_BOTH: 5699,
  SOCCER_SCORER_PERIOD_10MINUTES: 5700,
  SOCCER_SCORER_PERIOD_20MINUTES: 5701,
  SOCCER_NUMBER_OF_CARDS_BY_PLAYER: 5711,
  SOCCER_DECISIVE_PLAYER: 6037,
  BASKETBALL_WINNER: 2706,
  BASKETBALL_PLAYER_TEAM2_POINTS: 4968,
  BASKETBALL_PLAYER_TEAM2_REBOUNDS: 4969,
  BASKETBALL_PLAYER_TEAM2_ASSISTS: 4970,
  BASKETBALL_PLAYER_TEAM2_TRIPLE: 4971,
  BASKETBALL_PLAYER_TEAM1_POINTS: 4442,
  BASKETBALL_PLAYER_TEAM1_REBOUNDS: 4438,
  BASKETBALL_PLAYER_TEAM1_ASSISTS: 4437,
  BASKETBALL_PLAYER_TEAM1_TRIPLE: 4436,
  TENNIS_WINNER: 3624,
  FOOTBALL_WINNER: 2707,
  ICE_HOCKEY_WINNER: 3181,
  ICE_HOCKEY_SIMPLE_SCORER: 3816,
  ICE_HOCKEY_MULTI_SCORER: 4479,
  ICE_HOCKEY_MULTI_SCORER_2: 5838,
  ICE_HOCKEY_MULTI_SCORER_3: 5839,
  ICE_HOCKEY_SCORER_FIRST_PERIOD: 5840,
  ICE_HOCKEY_SCORER_SECOND_PERIOD: 5841,
  ICE_HOCKEY_SCORER_THIRD_PERIOD: 5842,
  ICE_HOCKEY_NEXT_SCORER: 5844,
  FOOTBALL_SIMPLE_SCORER: 4874,
  FOOTBALL_MULTI_SCORER: 4910,
  RUGBY_WINNER: 3183,
  RUGBY_SIMPLE_SCORER: 4873,
  RUGBY_MULTI_SCORER: 4460,
  RUGBY_LEAGUE_SIMPLE_SCORER: 4872,
  RUGBY_LEAGUE_MULTI_SCORER: 4774,
  RUGBY_7S_SIMPLE_SCORER: 4871,
  RUGBY_7S_MULTI_SCORER: 4697,
  RUGBY_13_WINNER: 4740,
  SOCCER_QUALIFICATION: 3140,
  SOCCER_WINNER_BRACKET_FINAL_WINNER: 3658,
  SOCCER_LOOSER_BRACKET_FINAL_WINNER: 3773,
  HANDBALL_SCORERS_PLAYER: 5729,
  SOCCER_RESULT_AFTER_X_MINUTES: 5392,
  SOCCER_NUMBER_OF_GOALS_AFTER_X_MINUTES: 5393,
  SOCCER_RESULT_10_MINUTES_FROM_X_TO_Y: 3513,
  SOCCER_NUMBER_OF_GOALS_10_MINUTES_FROM_X_TO_Y: 3463,
  SOCCER_TEAM_TO_SCORE_GOAL_10_MINUTES_FROM_X_TO_Y: 3765,
  BASKETBALL_PLAYER_TO_SCORE_A_DOUBLE_DOUBLE: 6031,
  BASKETBALL_PLAYER_TO_SCORE_A_TRIPLE_DOUBLE: 6032,
  HANDBALL_TOTAL_GOALS_OVERTIME: 2869,
  HANDBALL_GOAL_DIFFERENCE_HANDICAP: 3093,
  HANDBALL_GOAL_DIFFERENCE_OVERTIME_HANDICAP: 2695,
  HANDBALL_RESULT_1ST_HALF: 3600,
  HANDBALL_TOTAL_GOALS_1ST_HALF: 2533,
  HANDBALL_GOAL_DIFFERENCE_1ST_HALF_HANDICAP: 3494,
  HANDBALL_RESULT_1ST_HALF_DRAW_NO_BET: 3441,
  HANDBALL_RESULT_1ST_HALF_DOUBLE_CHANCE: 3404,
  HANDBALL_GOAL_DIFFERENCE_1ST_HALF_WINNING_MARGIN: 3758,
  HANDBALL_TOTAL_GOALS_1ST_HALF_RANGE_OF_GOALS: 3326,
  HANDBALL_GOALS_PER_TEAM_1ST_HALF_TOTAL_GOALS_FOR_COMPETITOR_1: 2395,
  HANDBALL_GOALS_PER_TEAM_1ST_HALF_TOTAL_GOALS_FOR_COMPETITOR_2: 2802,
  HANDBALL_RESULT_HALF_TIME_FULL_TIME: 2970,
  HANDBALL_GOAL_DIFFERENCE_WINNING_MARGIN: 3394,
  HANDBALL_GOALS_PER_TEAM_TOTAL_GOALS_FOR_COMPETITOR_1: 2618,
  HANDBALL_GOALS_PER_TEAM_RANGE_OF_GOALS_BY_COMPETITOR_1: 3238,
  HANDBALL_GOALS_PER_TEAM_RANGE_OF_GOALS_BY_COMPETITOR_2: 3674,
  HANDBALL_TOTAL_GOALS_FOR_COMPETITOR_2: 2683,
  SOCCER_PLAYER_STATS_NUMBER_OF_SHOTS_ON_GOAL_BY_THE_PLAYER: 3311,
  SOCCER_PLAYER_STATS_NUMBER_OF_SHOTS_BY_THE_PLAYER: 2747,
  SOCCER_PLAYER_STATS_NUMBER_OF_ASSISTS_MADE_BY_THE_PLAYER: 3361,
  SOCCER_PLAYER_STATS_NUMBER_OF_PASSES_BY_THE_PLAYER: 3304,
  SOCCER_TEAM_STATS_NUMBER_OF_SHOTS: 6202,
  SOCCER_TEAM_STATS_NUMBER_OF_SHOTS_FOR_COMPETITOR_1: 6203,
  SOCCER_TEAM_STATS_NUMBER_OF_SHOTS_FOR_COMPETITOR_2: 6204,
  SOCCER_TEAM_STATS_NUMBER_OF_SHOTS_ON_GOAL: 6205,
  SOCCER_TEAM_STATS_NUMBER_OF_SHOTS_ON_GOAL_FOR_COMPETITOR_1: 6206,
  SOCCER_TEAM_STATS_NUMBER_OF_SHOTS_ON_GOAL_FOR_COMPETITOR_2: 6207,
  SOCCER_CORNERS_TOTAL_CORNERS_FOR_COMPETITOR_1: 3676,
  SOCCER_CORNERS_TOTAL_CORNERS_FOR_COMPETITOR_2: 3104,
  SOCCER_CORNERS_TOTAL_CORNERS: 3621,
  TENNIS_GAME_GAP: 3273,
  TENNIS_SET_X_GAME_GAP: 3823,

  // Formula 1
  RACE_WINNER: 5153,
  RACE_TOP_3: 5173,
  RACE_TOP_6: 4944,
  RACE_TOP_10: 4943,

  FORMULA_1_WINNER: 5399,
  FORMULA_1_TOP_2: 6212,
  FORMULA_1_TOP_3: 5398,
  FORMULA_1_TOP_6: 6209,
  FORMULA_1_TOP_10: 6208,
  FORMULA_1_FASTEST_LAP: 5400,

  // Moto
  MOTO_WINNER: 5170,
  MOTO_TOP_3: 5805,
  MOTO_TOP_6: 5807,
  MOTO_TOP_10: 5808,
});
export type BetType = ObjectValuesUnionType<typeof BetTypes>;

export const NewBetTypesByLicence = new Proxy<Record<Licence, Array<BetType>>>(
  {
    // specific new betTypeIds for each licence
    [Licences.FR]: [
      BetTypes.SOCCER_RESULT_AFTER_X_MINUTES,
      BetTypes.SOCCER_NUMBER_OF_GOALS_AFTER_X_MINUTES,
      BetTypes.SOCCER_RESULT_10_MINUTES_FROM_X_TO_Y,
      BetTypes.SOCCER_NUMBER_OF_GOALS_10_MINUTES_FROM_X_TO_Y,
      BetTypes.SOCCER_TEAM_TO_SCORE_GOAL_10_MINUTES_FROM_X_TO_Y,
      BetTypes.BASKETBALL_PLAYER_TO_SCORE_A_DOUBLE_DOUBLE,
      BetTypes.BASKETBALL_PLAYER_TO_SCORE_A_TRIPLE_DOUBLE,
      BetTypes.HANDBALL_TOTAL_GOALS_OVERTIME,
      BetTypes.HANDBALL_GOAL_DIFFERENCE_HANDICAP,
      BetTypes.HANDBALL_GOAL_DIFFERENCE_OVERTIME_HANDICAP,
      BetTypes.HANDBALL_RESULT_1ST_HALF,
      BetTypes.HANDBALL_TOTAL_GOALS_1ST_HALF,
      BetTypes.HANDBALL_GOAL_DIFFERENCE_1ST_HALF_HANDICAP,
      BetTypes.HANDBALL_RESULT_1ST_HALF_DRAW_NO_BET,
      BetTypes.HANDBALL_RESULT_1ST_HALF_DOUBLE_CHANCE,
      BetTypes.HANDBALL_GOAL_DIFFERENCE_1ST_HALF_WINNING_MARGIN,
      BetTypes.HANDBALL_TOTAL_GOALS_1ST_HALF_RANGE_OF_GOALS,
      BetTypes.HANDBALL_GOALS_PER_TEAM_1ST_HALF_TOTAL_GOALS_FOR_COMPETITOR_1,
      BetTypes.HANDBALL_GOALS_PER_TEAM_1ST_HALF_TOTAL_GOALS_FOR_COMPETITOR_2,
      BetTypes.HANDBALL_RESULT_HALF_TIME_FULL_TIME,
      BetTypes.HANDBALL_GOAL_DIFFERENCE_WINNING_MARGIN,
      BetTypes.HANDBALL_GOALS_PER_TEAM_TOTAL_GOALS_FOR_COMPETITOR_1,
      BetTypes.HANDBALL_GOALS_PER_TEAM_RANGE_OF_GOALS_BY_COMPETITOR_1,
      BetTypes.HANDBALL_GOALS_PER_TEAM_RANGE_OF_GOALS_BY_COMPETITOR_2,
      BetTypes.HANDBALL_TOTAL_GOALS_FOR_COMPETITOR_2,
      BetTypes.SOCCER_PLAYER_STATS_NUMBER_OF_SHOTS_ON_GOAL_BY_THE_PLAYER,
      BetTypes.SOCCER_PLAYER_STATS_NUMBER_OF_SHOTS_BY_THE_PLAYER,
      BetTypes.SOCCER_PLAYER_STATS_NUMBER_OF_ASSISTS_MADE_BY_THE_PLAYER,
      BetTypes.SOCCER_PLAYER_STATS_NUMBER_OF_PASSES_BY_THE_PLAYER,
      BetTypes.SOCCER_TEAM_STATS_NUMBER_OF_SHOTS,
      BetTypes.SOCCER_TEAM_STATS_NUMBER_OF_SHOTS_FOR_COMPETITOR_1,
      BetTypes.SOCCER_TEAM_STATS_NUMBER_OF_SHOTS_FOR_COMPETITOR_2,
      BetTypes.SOCCER_TEAM_STATS_NUMBER_OF_SHOTS_ON_GOAL,
      BetTypes.SOCCER_TEAM_STATS_NUMBER_OF_SHOTS_ON_GOAL_FOR_COMPETITOR_1,
      BetTypes.SOCCER_TEAM_STATS_NUMBER_OF_SHOTS_ON_GOAL_FOR_COMPETITOR_2,
      BetTypes.SOCCER_CORNERS_TOTAL_CORNERS_FOR_COMPETITOR_1,
      BetTypes.SOCCER_CORNERS_TOTAL_CORNERS_FOR_COMPETITOR_2,
      BetTypes.SOCCER_CORNERS_TOTAL_CORNERS,
      BetTypes.TENNIS_GAME_GAP,
      BetTypes.TENNIS_SET_X_GAME_GAP,
    ],
    [Licences.DE]: [],
    [Licences.IT]: [],
    [Licences.ES]: [],
    [Licences.PT]: [],
  },
  {
    get: (origin, key: Licence) => {
      // new betTypeIds for every licence
      const everyLicencesValue: Array<BetType> = [];

      const foundValue = origin[key];

      if (!foundValue) {
        return everyLicencesValue;
      }

      return [...everyLicencesValue, ...foundValue];
    },
  },
);

export const BetCategories = Object.freeze({
  RESULT: 1,
  MATCH: 2,
  SET: 3,
  GAME_TENNIS: 4,
  POINT_TENNIS: 5,
  INNINGS_BASEBALL: 6,
  FRAMES_SNOOKER: 7,
  AFTER_5_FRAMES_SNOOKER: 8,
  BREAK_SNOOKER: 9,
  LEG_DARTS: 10,
  _180_DARTS: 11,
  TOTAL_GOALS: 12,
  GOALS_DIFFERENCE: 13,
  TOTAL_POINTS: 14,
  POINTS_DIFFERENCE: 15,
  EXACT_SCORE: 16,
  SCORERS_SOCCER: 17,
  SCORERS_BASKETBALL: 18,
  HALF_TIME: 19,
  PERIOD: 20,
  QUARTER: 21,
  GOALS_PER_TEAM: 22,
  TRIES: 23,
  CORNERS: 24,
  CARDS: 25,
  EVEN_ODD: 26,
  SPECIAL_BETS: 27,
  OTHERS: 28,
  END_BOWLS: 29,
  VISIT_DARTS: 30,
  BALL_SNOOKER: 31,
  PITCH_BASEBALL: 32,
  HIT_BASEBALL: 33,
  HOMERUN: 34,
  TOUCHDOWN: 35,
  DRIVE_FOOTUS: 36,
  _10_15_MINS: 37,
  MAP: 38,
  MAPS_DIFFERENCE: 39,
  TOTAL_MAPS: 40,
  SCORERS_RUGBY: 41,
  KILLS: 42,
  GOAL_TYPE: 43,
  COMBINED_BETS: 44,
  HEAD_TO_HEAD: 45,
  WINNER: 46,
  GROUPS: 47,
  KNOCKOUT_PHASE: 48,
  TOP_X: 49,
  CONFERENCES: 50,
  DIVISIONS: 51,
  PLAYOFFS: 52,
  NUMBER_OF_VICTORIES: 53,
  SHOOTS: 54,
  PLAYER_PROPS: 55,
  COMPETITOR_PROPS: 60,
});
export type BetCategorie = ObjectValuesUnionType<typeof BetCategories>;
